class CHUsage {
    constructor(
        public name:string,  
        public id?: number
    ) {}

    public static EmptyInstance(): CHUsage{
        return new CHUsage("", -1);
    }

//   public static Display(chusage: CHUsage): string {
//     return chusage.name === "Other"
//       ? "Other"
//       : chusage.name!;
//   }
}

class CHUsageInDTO{
    constructor(
        public ch_usage_id: number,
        public description: string
    ){}
    
    public static EmptyInstance(): CHUsageInDTO{
        return new CHUsageInDTO(-1, "");
    }

    public static fromCHUsage(chu: CHUsage, description: string): CHUsageInDTO{
        return new CHUsageInDTO(chu.id !== undefined ? chu.id : -1, description);
    }
}


class CHUsageOutDTO{
    constructor(
        public ch_usage: CHUsage,
        public description: string
    ){}
    
    public static EmptyInstance(): CHUsageOutDTO{
        return new CHUsageOutDTO(CHUsage.EmptyInstance(), "");
    }

    public static fromCHUsage(chu: CHUsage, description: string): CHUsageOutDTO{
        return new CHUsageOutDTO(chu, description);
    }


    public static Display(chusage: CHUsageOutDTO): string {
        return chusage.ch_usage.name === "Other"
        ? "Other"
        : chusage.ch_usage.name!;
    }
}
 


export{
    CHUsage,
    CHUsageInDTO,
    CHUsageOutDTO
}